import * as React from 'react';
import { st, classes } from './TextButton.st.css';
import './TextButton.responsive.st.css';
import TextBase from '../TextBase';
import { dataHooks } from './constants';
import { BaseUiNextContext } from '../../utils/BaseUINextContext';
const TextButton = ({ className, dataHook, children, size = 'medium', weight = 'normal', skin = 'standard', underline, prefix, suffix, disabled, onClick, ...props }) => {
    const context = React.useContext(BaseUiNextContext);
    const defaultUnderlineProp = underline
        ? underline
        : context?.theme === 'responsive'
            ? 'none'
            : 'onMouseHover';
    return (React.createElement("button", { "data-hook": dataHook, onClick: onClick, disabled: disabled, className: st(classes.root, {
            size,
            skin,
            disabled,
            weight,
            underline: defaultUnderlineProp,
            prefix: Boolean(prefix),
            suffix: Boolean(suffix),
        }, className) },
        prefix && React.createElement("div", { "data-hook": dataHooks.prefixIcon }, prefix),
        React.createElement(TextBase, { className: classes.text, ...props, type: "a" }, children),
        suffix && React.createElement("div", { "data-hook": dataHooks.suffixIcon }, suffix)));
};
export default TextButton;
//# sourceMappingURL=TextButton.js.map